<button mat-button (click)="toggleHidden()" class="close-button">
  <span *ngIf="hidden" class="material-icons">keyboard_arrow_down</span>
  <span *ngIf="!hidden" class="material-icons">keyboard_arrow_up</span>
</button>
<form *ngIf="!hidden">
  <div fxLayout="column">
    <div *ngIf="connectStatus">{{connectStatus}}</div>
    <div *ngIf="loginStatus">{{loginStatus}}</div>
    <div *ngIf="gameStatus">{{gameStatus}}</div>
    <div *ngIf="worldsStatus">{{worldsStatus}}</div>
    <div *ngIf="worldStatus">{{worldStatus}}</div>
    <div *ngIf="roomStatus">{{roomStatus}}</div>
    <div *ngIf="client.mode">Joined as {{client.mode}}</div>
  </div>
  <mat-checkbox name="autoConnect"
                [(ngModel)]="client.settings.autoConnect" (change)="onChange()">
    <mat-label>Auto-connect</mat-label>
  </mat-checkbox>
  <div *ngIf="!client.connected">
    <mat-form-field class="full-width">
      <mat-label>Server URL</mat-label>
      <input [matInput] placeholder="eg ws://gengine.sourcepaint.cz"
             name="serverUrl"
             [(ngModel)]="client.settings.serverUrl" (change)="onChange()">
    </mat-form-field>

    <div fxLayout="row">
      <button [matInput] mat-raised-button (click)="connect().catch()">Connect</button>
    </div>
  </div>
  <div *ngIf="client.connected && !client.player">
    <mat-form-field class="full-width">
      <mat-label>Username</mat-label>
      <input [matInput] placeholder="eg your name"
             name="username"
             [(ngModel)]="client.settings.username" (change)="onChange()">

    </mat-form-field>

    <div fxLayout="row">
      <button [matInput] mat-raised-button (click)="login().catch()">Login</button>
    </div>
  </div>
  <div *ngIf="worlds && !client.world" >
    <mat-form-field appearance="fill" *ngIf="!newWorld">
      <mat-label>Pick a group</mat-label>
      <mat-select [(ngModel)]="world" name="world" (change)="onChange()" (selectionChange)="onChange()">
        <mat-option *ngFor="let w of worlds" [value]="w.name">
          {{w.name}} - ({{w.players.join(', ')}})
        </mat-option>
        <mat-option [value]="''">
          [Create new...]
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="full-width" *ngIf="newWorld">
      <mat-label>Group Name</mat-label>
      <input [matInput] placeholder="eg me and you"
             name="world"
             [(ngModel)]="client.settings.world" (change)="onChange()">
    </mat-form-field>
    <div fxLayout="row">
      <button [matInput] mat-raised-button (click)="joinWorld().catch()">Enter group</button>
    </div>
  </div>
  <div *ngIf="client.player && client.player.room">
    I am {{client.player.room.master?"master":"slave"}}<br/>
    Players in the room:
    <div *ngFor="let user of client.player.room.players" fxLayout="column">
      <div>* {{user.name}}</div>
    </div>
    <div fxLayout="row">
      <button [matInput] mat-raised-button (click)="leaveWorld().catch()">Leave group</button>
      <button *ngIf="client.player.room.canStart &&!game.started"
              [matInput] mat-raised-button (click)="start().catch()">Start</button>
    </div>
  </div>
</form>
